// removed by extract-text-webpack-plugin
module.exports = {"ba-over-x":"magazines_2WnqH"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Editor/components/ContentEditor/styles.scss
// module id = 1064
// module chunks = 1